<template>
  <a-row class="p-2">
    <a-col :lg="3" :md="4" :sm="6" class="text-gray">
      <a-icon type="tag" />{{ " " }}
      <span class="ml-2">{{ field.name }}</span>
    </a-col>
    <a-col :lg="21" :md="20" :sm="18" class="text-dark">
      <span v-if="typeof convertedData === 'string'">{{ convertedData }}</span>
      <span v-else>
        <span v-for="(i, index) in convertedData" :key="i">
          <span v-if="index > 0">, </span> {{ i }}
        </span>
      </span>
    </a-col>
  </a-row>
</template>
<script>
export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  computed: {
    convertedData() {
      if (this.field?.value && this.field.value[0] === "[") {
        return JSON.parse(this.field.value);
      } else {
        return this.field.value;
      }
    },
  },
};
</script>
